// extracted by css-extract-rspack-plugin
export default {"Item":"AssigneePickerBase-module__Item__sPVJjUT"};